export const UPDATE_TR_DETAILS_REQUEST = "UPDATE_TR_DETAILS_REQUEST";
export const UPDATE_TR_DETAILS_SUCCESS = "UPDATE_TR_DETAILS_SUCCESS";
export const UPDATE_TR_DETAILS_FAILURE = "UPDATE_TR_DETAILS_FAILURE";
export const DOWNLOAD_IMAGE = "DOWNLOAD_IMAGE";
export const DOWNLOAD_FILES_REQUEST = "DOWNLOAD_FILES_REQUEST";
export const DOWNLOAD_FILES_SUCCESS = "DOWNLOAD_FILES_SUCCESS";


export const updateTrDetailsRequest = (payload) => {
  return {
    type: UPDATE_TR_DETAILS_REQUEST,
    payload: payload,
  };
};

export const updateTrDetailsSuccess = (payload) => {
  return {
    type: UPDATE_TR_DETAILS_SUCCESS,
    payload,
  };
};

export const updateTrDetailsFailure = (payload) => {
  return {
    type: UPDATE_TR_DETAILS_FAILURE,
    payload,
  };
};

export const downloadFilesRequest = (payload) => {
  return {
    type: DOWNLOAD_FILES_REQUEST,
    payload,
  };
};

export const downloadFilesSuccess = (payload) => {
  return {
    type: DOWNLOAD_FILES_SUCCESS,
    payload,
  };
};


export const downloadImageRequest = (payload) => {
  return {
    type: DOWNLOAD_IMAGE,
    payload,
  };
};
